const sizeToColor: Record<number, string> = {
  1: '#000000',
  2: '#363649',
  3: '#6f6f6f',
  4: '#aba9a9',
  5: '#cccccc',
};

const getColorForSize = (size: number, fallback = '#6f6f6f'): string =>
  sizeToColor[size] || fallback;

export { getColorForSize, sizeToColor };
